import _ from 'lodash'

import {
  ALERTA_PROCESSO_ATUALIZADO_RECUPERADO,
  ALERTAS_RECUPERADOS,
  ALERTAS_MARCADAS_COMO_LIDAS
} from '../actions/alertasActions'
import { USER_LOGOUT } from '../actions/authenticationJwtActions'

const INITIAL_STATE = {
  processosAtualizados: [],
  lidas: [],
  naoLidas: [],
  qtdeAlertas: 0,
  qtdeAlertasLidas: 0,
  qtdeAlertasNaoLidas: 0
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ALERTA_PROCESSO_ATUALIZADO_RECUPERADO: {
      const { numeroFormatado } = action.payload
      const processosAtualizados = _.uniq([].concat(...state.processosAtualizados, numeroFormatado))
      return { ...state, processosAtualizados }
    }
    case ALERTAS_RECUPERADOS: {
      const lidas = [].concat(action.payload.lidas)
      const naoLidas = [].concat(action.payload.naoLidas)
      const qtdeAlertasLidas = _.size(lidas)
      const qtdeAlertasNaoLidas = _.size(naoLidas)
      const qtdeAlertas = qtdeAlertasLidas + qtdeAlertasNaoLidas
      return { ...state, lidas, naoLidas, qtdeAlertas, qtdeAlertasLidas, qtdeAlertasNaoLidas }
    }
    case ALERTAS_MARCADAS_COMO_LIDAS: {
      return { ...state }
    }
    case USER_LOGOUT:
      return INITIAL_STATE
    default:
      return state
  }
}
